import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, ToggleButton, ToggleButtonGroup, Button, Chip, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";

const ShowerDescalingLog = ({ onClose, onSubmit, selectedTask, setOpenDefaultSnackbar }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store
  const [descaleStatus, setDescaleStatus] = useState(null);
  const [reason, setReason] = useState("");
  const today = new Date();
  const todayDate = today.toISOString().split("T")[0];
  const [taskId, setTaskId] = useState(selectedTask?.id);

  useEffect(() => {
    if (!taskId && selectedTask?.id) {
      setTaskId(selectedTask.id);
    }
  }, [selectedTask?.id]); // Run only if `selectedTask.id` is not set

  const handleStatusChange = (event, newStatus) => {
    setDescaleStatus(newStatus);
  };

  const updateSubTask = async (taskId) => {
    if (!taskId) {
      console.error("Task ID is undefined. Cannot update.");
      return;
    }

    try {
      await axios.put(
        `/api/assessments/updateTask/${taskId}`,
        {
          status: "completed",
          checklist: [],
          updated_by: user?.username || "Unknown",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-user-role": user?.roleid || "",
          },
        }
      );
      setOpenDefaultSnackbar(true);
    } catch (error) {
      console.error("Error updating subtask:", error);
    }
  };

  const handleSubmit = async () => {
    const requestData = {
      date: todayDate,
      descaleStatus,
      reason: descaleStatus === "No" ? reason : "",
      completedBy: user.username,
    };

    try {
      // Make POST request to API
      await axios.post("/api/showerDescaling/log", requestData);

      if (taskId) {
        updateSubTask(taskId); // Use the stored task ID
      }

      // Optional callback function
      if (onSubmit) {
        onSubmit(requestData);
      }

      onClose(); // Close the form after successful submission
    } catch (error) {
      console.error("Error submitting shower descaling log:", error);
      alert("Failed to submit log. Please try again.");
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Chip
        label='Weekly Tasks'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "#1751D0",
          mb: 2,
        }}
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold", mb: 2 }}>Shower Descaling Log</Typography>
      <Typography sx={{ fontSize: "14px", color: "#757575", mb: 2 }}>
        Date: {todayDate} <span style={{ color: "#1751D0" }}>• {user.username}</span>
      </Typography>

      {/* Toggle Buttons */}
      <Grid container>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "14px", mb: 1 }}>Were All 3 Shower Heads Descaled?</Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <ToggleButtonGroup value={descaleStatus} exclusive onChange={handleStatusChange} sx={{ mb: 3 }}>
            <ToggleButton value='Yes' sx={{ textTransform: "none" }} color='primary'>
              Yes
            </ToggleButton>
            <ToggleButton value='No' sx={{ textTransform: "none" }} color='error'>
              No
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      {/* Reason Input */}
      {descaleStatus === "No" && (
        <>
          <Typography sx={{ fontSize: "14px", mb: 1 }}>If not, then please state why</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder='Provide a reason...'
            sx={{ mb: 3 }}
          />
        </>
      )}

      {/* Action Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button variant='outlined' onClick={onClose}>
          Previous
        </Button>
        <Button variant='contained' onClick={handleSubmit} disabled={!descaleStatus}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default ShowerDescalingLog;
